import vocabulary from './vocabulary.json'
import { advancedSubForAlias } from './advanced'

/**
 * A Workbench URL tab → where it lives now (plan §12):
 *   overview → next, specification → plan, prototype → screens (data);
 *   analytics / support / integration / source-control → advanced/<sub>
 *   (the `aliases` in advancedGroups.json).
 * Returns null when the id needs no redirect.
 */
export function redirectForTab(tab: string): { tab: string; sub?: string } | null {
  const legacy = (vocabulary.legacyTabs as Record<string, string>)[tab]
  if (legacy && !legacy.startsWith('_')) return { tab: legacy }
  const sub = advancedSubForAlias(tab)
  if (sub) return { tab: 'advanced', sub }
  return null
}

/** The store's remembered tab, migrated off an old id. */
export function canonicalTab(tab: string | null | undefined): string {
  if (!tab) return 'next'
  const r = redirectForTab(tab)
  return r ? r.tab : tab
}
